import React from 'react';
import { Link } from 'react-router-dom';
import "./ThankYou.css";

const ThankYou = () => {
  return (
    <div className="thankyou-page">
      <section className="section-padding">
        <div className="container">
          <div className="thankyou-card">
            <div className="thankyou-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <h1>Thank You!</h1>
            <p className="thankyou-message">
              Your message has been sent successfully. We've received your inquiry and our team will get back to you within 24 hours.
            </p>
            <div className="thankyou-actions">
              <Link to="/" className="btn"><i className="fas fa-home"></i> Back to Home</Link>
              <Link to="/services" className="btn btn-secondary"><i className="fas fa-list"></i> View Services</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ThankYou;
